export default __webpack_public_path__ + "static/media/4.f630dcc0.svg";